import React from "react";
import "../../../HomePage/AskedQuestion/NewAskedQuestion.css";

const DevForHireFAQ = () => {
  return (
    <div id="f&q">
      <div
        id="faq"
        style={{ zIndex: 2, background: "#FAFAFA" }}
        className="faq-section position-relative"
      >
        <div className="faq-box p-4 p-md-5 rounded-3">
          <div className="text-center mb-4 mb-md-5">
            <h2 className="fw-semibold Tech-heading  display-6">
              Questions That Usually Come Up Before Hiring
            </h2>
            <p className="text-muted database-text mb-0">
              We are more than a generic agency. Explore our Services and our
              Solutions for your business.
            </p>
          </div>

          <div className="row">
            <div className="col-12 col-lg-10 mx-auto">
              <div className="accordion custom-accordion" id="faqAccordion">
                {/* FAQ 1 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header " id="faqHeadingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseOne"
                      aria-expanded="true"
                      aria-controls="faqCollapseOne"
                    >
                      <span className="faq-num me-4 fw-semibold three">01</span>
                      <span className="faq-question  fqa-heading">
                        How quickly can we get started once we decide to move
                        forward?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="faqHeadingOne"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body small fqa-text text-muted px-3 px-md-5 ms-5 "
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Usually faster than people anticipate. Once we know the
                      role and what we expect the candidate to do, we shortlist
                      candidates fairly quickly and get into interviews without
                      dragging things out.
                    </div>
                  </div>
                </div>

                {/* FAQ 2 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseTwo"
                      aria-expanded="false"
                      aria-controls="faqCollapseTwo"
                    >
                      <span className="faq-num me-4 fw-semibold three">02</span>
                      <span className="faq-question  fqa-heading">
                        Will the developer or team work only on our project?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingTwo"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 px-md-5 ms-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Yes. Whether it is a solo developer or a dedicated team,
                      they work exclusively with you and focus only on your
                      product.
                    </div>
                  </div>
                </div>

                {/* FAQ 3 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseThree"
                      aria-expanded="false"
                      aria-controls="faqCollapseThree"
                    >
                      <span className="faq-num me-4 fw-semibold three">03</span>
                      <span className="faq-question fqa-heading ">
                        How much day to day management is needed from our side?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingThree"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 ms-5 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Not much. We take care of structure and oversight at the
                      internal level. You stay in on decisions, and not chasing
                      updates and managing tasks.
                    </div>
                  </div>
                </div>

                {/* FAQ 4 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseFour"
                      aria-expanded="false"
                      aria-controls="faqCollapseFour"
                    >
                      <span className="faq-num me-4 fw-semibold three">04</span>
                      <span className="faq-question  fqa-heading">
                        What if the developer is not the right fit?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingFour"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 ms-5 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      It happens sometimes. If something just does not feel
                      right early on, we change it or replace it in a short time
                      without making it a long-term issue.
                    </div>
                  </div>
                </div>

                {/* FAQ 5 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseFive"
                      aria-expanded="false"
                      aria-controls="faqCollapseFive"
                    >
                      <span className="faq-num me-4 fw-semibold  three">
                        05
                      </span>
                      <span className="faq-question fqa-heading">
                        Can we scale up or down later?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingFive"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body small fqa-text text-muted ms-5 px-3 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Absolutely. Many clients begin small and grow bigger once
                      things are settled. Scaling is not regarded as a
                      disruption, but is incorporated into the model.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevForHireFAQ;
